"use strict"
exports.__esModule = true;
exports.StoreAltIconConfig = {
  name: 'StoreAltIcon',
  height: 512,
  width: 640,
  svgPath: 'M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z',
  yOffset: 0,
  xOffset: 0,
};
exports.StoreAltIcon = require('../createIcon').createIcon(exports.StoreAltIconConfig);
exports["default"] = exports.StoreAltIcon;